module.exports = __webpack_public_path__ + "static/img/icon1.bb1b29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon1.png
// module id = 93jX
// module chunks = 0